import { fmtTs } from "./ccApi";

export const Section = ({ title, children, right, testid }) => (
  <section data-testid={testid} className="border border-white/10 bg-white/[0.03] rounded-md">
    <header className="flex items-center justify-between px-3 py-2 border-b border-white/10">
      <h4 className="text-[11px] uppercase tracking-[0.2em] text-zinc-400">{title}</h4>
      {right}
    </header>
    <div className="p-3 space-y-2">{children}</div>
  </section>
);

export const Pill = ({ tone = "zinc", children, testid }) => {
  const tones = {
    zinc: "bg-white/10 text-zinc-200", red: "bg-rose-500/20 text-rose-200 border border-rose-500/40",
    amber: "bg-amber-500/15 text-amber-200 border border-amber-500/40", green: "bg-emerald-500/15 text-emerald-200 border border-emerald-500/40",
    blue: "bg-sky-500/15 text-sky-200 border border-sky-500/40",
  };
  return <span data-testid={testid} className={`inline-flex items-center px-2 py-0.5 rounded-full text-[11px] ${tones[tone]}`}>{children}</span>;
};

export const ActionBtn = ({ children, onClick, tone = "default", testid, disabled, title }) => {
  const cls = {
    default: "border-white/15 text-zinc-200 hover:bg-white/10",
    danger: "border-rose-500/50 text-rose-200 hover:bg-rose-500/15",
    warn: "border-amber-500/50 text-amber-200 hover:bg-amber-500/15",
    good: "border-emerald-500/50 text-emerald-200 hover:bg-emerald-500/15",
  }[tone];
  return (
    <button type="button" data-testid={testid} onClick={onClick} disabled={disabled} title={title}
      className={`px-3 py-1.5 text-xs rounded-md border transition-colors disabled:opacity-40 disabled:cursor-not-allowed ${cls}`}>
      {children}
    </button>
  );
};

export const AuditRow = ({ row }) => (
  <div data-testid={`cc-audit-row-${row.id}`} className="grid grid-cols-[auto_1fr] gap-x-3 gap-y-0.5 text-xs py-2 border-b border-white/5 last:border-0">
    <span className={`mt-0.5 w-2 h-2 rounded-full ${row.result === "success" ? "bg-emerald-400" : row.result === "denied" ? "bg-rose-400" : "bg-amber-400"}`} />
    <div>
      <div className="flex flex-wrap items-center gap-2">
        <span className="font-mono text-white">{row.action}</span>
        <Pill tone={row.result === "success" ? "green" : row.result === "denied" ? "red" : "amber"}>{row.result}</Pill>
        <span className="text-zinc-500">{fmtTs(row.ts)}</span>
      </div>
      <div className="text-zinc-400">
        by <span className="text-zinc-200">@{row.actor_handle || "anonymous"}</span> <span className="text-zinc-500">({row.actor_role})</span>
        {row.target_id && <> → <span className="text-zinc-300">{row.target_type}</span> <span className="font-mono text-zinc-500">{String(row.target_id).slice(0, 8)}…</span></>}
      </div>
      {row.reason && <div className="text-zinc-300 italic">“{row.reason}”</div>}
      {row.meta?.why && <div className="text-rose-300">denied: {row.meta.why}</div>}
    </div>
  </div>
);

export const Empty = ({ children }) => <div className="text-xs text-zinc-500 py-4 text-center">{children}</div>;
